import { getCurrentYear } from "@utils/getCurrentYear";

/**
 * Returns copyright text with the current year
 * @param {string} companyName - Name of the company/organization
 * @returns {string} Formatted copyright text
 */
export const getCopyrightText = (footerTitle: string, projectTitle: string) => {
    const currentYear = getCurrentYear();
    return footerTitle.replace('{{year}}', currentYear) + ' ' + projectTitle;
  }; 